export const wechat_zhCN = {
  'wechat.authorize.n01.txt01': `因接口权限限制，不同的公众号权限不同，请查看微信接口权限说明。`,
  'wechat.authorize.n01.txt02': `当同一平台绑定多个账号时，如果需要实现用户通，请按平台规范进行账号互通操作。`,
  'wechat.authorize.n01.btn03': `账号绑定`,
  'wechat.authorize.c01.lbl01': `名称`,
  'wechat.authorize.c01.lbl02': `唯一标识`,
  'wechat.authorize.c01.lbl03': `APPID`,
  'wechat.authorize.c01.lbl04': `账号类型`,
  'wechat.authorize.c01.lbl05': `已获权限`,
  'wechat.authorize.c01.lbl06': `绑定时间`,
  'wechat.authorize.d01.lbl01': `公众号权限列表`,
  'wechat.official.n01.rdo01': `公众号`,
  'wechat.official.n01.btn02': `同步至微信`,
  'wechat.official.c01.lbl01': `模板`,
  'wechat.official.c01.lbl02': `模板ID`,
  'wechat.official.c01.lbl03': `模板标题`,
  'wechat.official.c01.lbl04': `数量`,
  'wechat.official.c01.lbl05': `操作`,
  'wechat.official.c01.btn06': `添加`,
  'wechat.official.n02.lbl01': `模板消息名称`,
  'wechat.official.n02.rdo02': `类型`,
  'wechat.official.c02.lbl09': `模板消息`,
  'wechat.official.n03.lbl02': '模版消息',
  'wechat.official.c02.lbl01': `模板消息名称`,
  'wechat.official.c02.lbl02': `模板标题`,
  'wechat.official.c02.lbl03': `类型`,
  'wechat.official.c02.lbl04': `创建人`,
  'wechat.official.c02.lbl05': `创建时间`,
  'wechat.official.c02.lbl06': `操作`,
  'wechat.official.c02.lbl07': `编辑`,
  'wechat.official.c02.lbl08': `删除`,
  'wechat.official.d01.txt01': `确认删除此条模板消息吗？`,
  'wechat.official.add.n01.lbl01': `模板消息名称`,
  'wechat.official.add.n01.rdo02': `活动类型`,
  'wechat.official.add.n01.placeholder03': `first`,
  'wechat.official.add.n01.lbl04': `keyword1`,
  'wechat.official.add.n01.lbl05': `keyword2`,
  'wechat.official.add.n01.lbl06': `keyword3`,
  'wechat.official.add.n01.lbl07': `keyword4`,
  'wechat.official.add.n01.lbl08': `备注`,
  'wechat.official.add.n01.lbl09': `appid`,
  'wechat.official.add.n01.lbl10': `pagepath`,
  'wechat.official.add.n01.lbl11': `url`,
  'wechat.official.add.d01.lbl01': `字段`,
  'wechat.official.add.d01.lbl02': `添加字段`,
  'wechat.official.add.d02.lbl01': `选择颜色`,
  'wechat.official.add.n02.txt01': `模板消息名称为必填项`,
  'wechat.official.add.n02.txt02': `模板消息名称不能为空`,
  'wechat.official.add.n02.txt03': `活动类型为必填项`,

  'wechat.official.edit.n01.lbl01': `模板消息名称`,
  'wechat.official.edit.n01.rdo02': `活动类型`,
  'wechat.official.edit.n01.placeholder03': `first`,
  'wechat.official.edit.n01.lbl04': `keyword1`,
  'wechat.official.edit.n01.lbl05': `keyword2`,
  'wechat.official.edit.n01.lbl06': `keyword3`,
  'wechat.official.edit.n01.lbl07': `keyword4`,
  'wechat.official.edit.n01.lbl08': `备注`,
  'wechat.official.edit.n01.lbl09': `appid`,
  'wechat.official.edit.n01.lbl10': `pagepath`,
  'wechat.official.edit.n01.lbl11': `url`,
  'wechat.official.edit.n02.lbl01': `预览`,
  'wechat.official.d01.lbl01': `删除`,
  'wechat.authorize.n02.lbl01': `微信公众号`,
};

export const wechat_enUS = {
  'wechat.authorize.n01.txt01': `OFFICIAL ACOUNTS HAVE DIFFERENT AUTHORITIES ACCORDING TO THEIR INTERFACES.READ WECHAT DEVELOPERS FOR MORE.`,
  'wechat.authorize.n01.txt02': `REMEMBER FOLLOW PLATFORM SPECIFICATION WHEN DOING MEMBER-SHARING ON BINDING MULTIPLE ACCOUNTS TO A SPECIFIC PLATFORM.`,
  'wechat.authorize.n01.btn03': `BINDING ACCOUNTS`,
  'wechat.authorize.c01.lbl01': `NAME`,
  'wechat.authorize.c01.lbl02': `UNIQUELY IDENTIFIES`,
  'wechat.authorize.c01.lbl03': `APPID`,
  'wechat.authorize.c01.lbl04': `SUBSRIBE`,
  'wechat.authorize.c01.lbl05': `AUTHORIZE GAINED`,
  'wechat.authorize.c01.lbl06': `TIME OF BINDING`,
  'wechat.authorize.d01.lbl01': `AUTHORIZE GAINED LIST`,
  'wechat.official.n01.rdo01': `OFFICIAL ACOUNTS`,
  'wechat.official.n01.btn02': `SYNCHRONIZE TO WECHAT`,
  'wechat.official.c01.lbl01': `TEMPLET`,
  'wechat.official.c01.lbl02': `TEMPLET ID`,
  'wechat.official.c01.lbl03': `TEMPLET TITLE`,
  'wechat.official.c01.lbl04': `QUANTITY`,
  'wechat.official.c01.lbl05': `ACTION`,
  'wechat.official.c01.btn06': `ADD`,
  'wechat.official.n02.lbl01': `TEMPLET NAME`,
  'wechat.official.n02.rdo02': `TEMPLET TYPE`,
  'wechat.official.n03.lbl02': 'Templet Message',
  'wechat.official.c02.lbl01': `TEMPLET NAME`,
  'wechat.official.c02.lbl02': `TEMPLET TITLE`,
  'wechat.official.c02.rdo02': `TYPE`,
  'wechat.official.c02.lbl04': `CREATOR`,
  'wechat.official.c02.lbl05': `CREATE TIME`,
  'wechat.official.c02.lbl06': `ACTION`,
  'wechat.official.c02.lbl07': `EDIT`,
  'wechat.official.c02.lbl08': `DELETE`,
  'wechat.official.d01.txt01': `Are you sure you want to delete ?`,
  'wechat.official.add.n01.lbl01': `TEMPLET NAME`,
  'wechat.official.add.n01.rdo02': `TYPE`,
  'wechat.official.add.n01.placeholder03': `FIRST`,
  'wechat.official.add.n01.lbl04': `KEYWORD1`,
  'wechat.official.add.n01.lbl05': `KEYWORD2`,
  'wechat.official.add.n01.lbl06': `KEYWORD3`,
  'wechat.official.add.n01.lbl07': `KEYWORD4`,
  'wechat.official.add.n01.lbl08': `REMARK`,
  'wechat.official.add.n01.lbl09': `APPID`,
  'wechat.official.add.n01.lbl10': `PAGEPATH`,
  'wechat.official.add.n01.lbl11': `URL`,
  'wechat.official.add.d01.lbl01': `Field`,
  'wechat.official.add.d01.lbl02': `Add Field`,
  'wechat.official.add.d02.lbl01': `Choose Color`,
  'wechat.official.add.n02.txt01': `Templet Name must be filled in`,
  'wechat.official.add.n02.txt02': `Templet Name must be filled in`,
  'wechat.official.add.n02.txt03': `Event Name must be filled in`,

  'wechat.official.edit.n01.lbl01': `TEMPLET NAME`,
  'wechat.official.edit.n01.rdo02': `TYPE`,
  'wechat.official.edit.n01.placeholder03': `FIRST`,
  'wechat.official.edit.n01.lbl04': `KEYWORD1`,
  'wechat.official.edit.n01.lbl05': `KEYWORD2`,
  'wechat.official.edit.n01.lbl06': `KEYWORD3`,
  'wechat.official.edit.n01.lbl07': `KEYWORD4`,
  'wechat.official.edit.n01.lbl08': `REMARK`,
  'wechat.official.edit.n01.lbl09': `APPID`,
  'wechat.official.edit.n01.lbl10': `PAGEPATH`,
  'wechat.official.edit.n01.lbl11': `URL`,
  'wechat.official.edit.n02.lbl01': `REVIEW`,
  'wechat.official.d01.lbl01': `DELTETE`,
  'wechat.authorize.n02.lbl01': `wehcat official accounts`, //微信公众号
};
